module.exports = __webpack_public_path__ + "img/iconInfo.ae2a9962.png";